import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';
import Services from '../components/Services.jsx';
import img24 from '../images/24.jpg';
import img25 from '../images/25.jpg';
import '../styles/ModalidadSatelitePage.css';

export default function ModalidadSatelitePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App">
      <Header />
      <main className="tm-satelite-page">
        <section
          className="tm-satelite-hero"
          style={{ backgroundImage: `url(${img24})` }}
          aria-label="Presentación modalidad satélite"
        >
          <div className="tm-satelite-hero-scrim" aria-hidden="true" />
          <div className="tm-satelite-hero-inner tm-container">
            <h1 className="tm-satelite-hero-headline">
              <span className="tm-satelite-hero-line tm-satelite-hero-line--lead">
                CON LA MODALIDAD SATELITE DE TMSTUDIO
              </span>
              <span className="tm-satelite-hero-accent-wrap">
                <span className="tm-satelite-hero-line--accent">NO HAY FRONTERAS</span>
              </span>
            </h1>
          </div>
        </section>

        <section
          className="tm-satelite-info tm-container"
          aria-labelledby="satelite-info-title"
        >
          <header className="tm-satelite-info-header">
            <h2 id="satelite-info-title" className="tm-satelite-info-title">
              Lo esencial de la modalidad satélite
            </h2>
            <p className="tm-satelite-info-subtitle">
              Conoce si es para ti, qué incluye el acompañamiento y cómo agendar tu entrevista desde donde estés.
            </p>
          </header>
          <div className="tm-satelite-cards">
            <div className="tm-satelite-card">
              <h2>¿Para quién es?</h2>
              <p>Para modelos que quieren empezar o mejorar, y necesitan guía profesional, seguimiento y apoyo en el proceso.</p>
            </div>
            <div className="tm-satelite-card">
              <h2>¿Qué incluye?</h2>
              <p>Acompañamiento, lineamientos claros, optimización de perfil y recomendaciones para mejorar rendimiento.</p>
            </div>
            <div className="tm-satelite-card">
              <h2>¿Cómo aplico?</h2>
              <p>Agenda tu entrevista y recibe acompañamiento para avanzar con claridad, desde cualquier lugar.</p>
            </div>
          </div>
        </section>

        <section className="tm-satelite-req tm-container" aria-labelledby="requisitos-title">
          <div className="tm-satelite-req-header">
            <h2 id="requisitos-title" className="tm-satelite-req-title">Requisitos</h2>
            <p className="tm-satelite-req-subtitle">
              Así tu transmisión se ve y se siente profesional, y tú trabajas con tranquilidad. Si te falta algo,
              no te preocupes: te orientamos con tips claros y, si hace falta, en la compra de equipos.
            </p>
          </div>

          <div className="tm-satelite-req-grid">
            <article className="tm-satelite-req-card">
              <div className="tm-satelite-req-icon" aria-hidden="true">
                <span className="material-symbols-outlined">bed</span>
              </div>
              <h3>Espacio</h3>
              <ul>
                <li>Espacio privado (apto / habitación)</li>
                <li>Decoración adecuada</li>
              </ul>
            </article>

            <article className="tm-satelite-req-card">
              <div className="tm-satelite-req-icon" aria-hidden="true">
                <span className="material-symbols-outlined">speed</span>
              </div>
              <h3>Internet</h3>
              <ul>
                <li>Internet de alta velocidad</li>
                <li>Preferiblemente fibra óptica</li>
              </ul>
            </article>

            <article className="tm-satelite-req-card">
              <div className="tm-satelite-req-icon" aria-hidden="true">
                <span className="material-symbols-outlined">calendar_month</span>
              </div>
              <h3>Disponibilidad</h3>
              <ul>
                <li>Buena disponibilidad de tiempo</li>
                <li>Para transmitir con constancia</li>
              </ul>
            </article>

            <article className="tm-satelite-req-card">
              <div className="tm-satelite-req-icon" aria-hidden="true">
                <span className="material-symbols-outlined">videocam</span>
              </div>
              <h3>Equipos</h3>
              <ul>
                <li>Iluminación profesional</li>
                <li>Cámara web 4K (ideal)</li>
                <li>Computador de alta gama</li>
              </ul>
            </article>
          </div>
        </section>

        <Services />

        <section
          className="tm-satelite-endcap"
          style={{ backgroundImage: `url(${img25})` }}
        >
          <div className="tm-satelite-endcap-scrim" aria-hidden="true" />
          <div className="tm-satelite-endcap-inner tm-container">
            <p className="tm-satelite-kicker">SERVICIO</p>
            <h2 className="tm-satelite-title">Modalidad satélite</h2>
            <p className="tm-satelite-subtitle">
              Una modalidad pensada para modelos que quieren trabajar con acompañamiento, procesos claros y una ruta de crecimiento, sin estar físicamente en el estudio.
            </p>
            <div className="tm-satelite-hero-actions">
              <Link className="btn-hover gold-gradient-bg tm-satelite-primary" to="/registro">
                Agendar entrevista
                <span className="material-symbols-outlined" style={{ fontSize: '1.125rem' }}>arrow_forward</span>
              </Link>
              <Link className="tm-satelite-secondary" to="/#beneficios">
                Ver beneficios del estudio
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

